import { Dropdown, IDropdownOption, Stack, Label, PrimaryButton, TextField, Dialog, DialogType, DialogFooter, DefaultButton } from "@fluentui/react";
import { useState } from "react";
import styles from "./FeedbackContent.module.css";
import { feedbackApi} from "../../api";

interface Props {
  className: string;
  activeCitation: string | undefined;
  citationHeight: string;
  // answer: ChatAppResponse;
}

const feedbackOptions: IDropdownOption[] = [
  { key: 'Yes', text: 'Yes' },
  { key: 'No', text: 'No' },
  { key: 'Partial', text: 'Partial' },
  { key: 'Tech to Verify', text: 'Tech to Verify' },
];

const noOptionDropdownOptions: IDropdownOption[] = [
  { key: 'Not Available', text: 'Not Available' },
  { key: 'Not Relevant', text: 'Not Relevant' },
  { key: 'Tech Consultation Required', text: 'Tech Consultation Required' },
  { key: 'Other', text: 'Other' },
];

export const FeedbackContent = (props: { closeModal: any; }) => {
  const [selectedFeedback, setSelectedFeedback] = useState<string | undefined>(undefined);
  const [additionalDetails, setAdditionalDetails] = useState<string | undefined>(undefined);
  const [noDropdownSelection, setNoDropdownSelection] = useState<string | undefined>(undefined);
  const [isDialogVisible, setIsDialogVisible] = useState<boolean>(false);
  const [isTechDialogVisible, setIsTechDialogVisible] = useState<boolean>(false);

  const handleFeedbackChange = (event: React.FormEvent<HTMLDivElement>, option: IDropdownOption | undefined) => {
    const feedback = option?.text;
    setSelectedFeedback(feedback);

    // Show the dialog when "Yes" is selected
    if (feedback === 'Yes') {
      setIsDialogVisible(true);
    }

    // Show the tech dialog when "Tech to Verify" is selected
    if (feedback === 'Tech to Verify') {
      setIsTechDialogVisible(true);
    }
  };

  const handleAdditionalDetailsChange = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, 
    newValue?: string
  ) => {
    setAdditionalDetails(newValue);
  };

  const handleNoOptionDropdownChange = (
    event: React.FormEvent<HTMLDivElement>, 
    option: IDropdownOption | undefined
  ) => {
    setNoDropdownSelection(option?.text);
  };
  const {closeModal}=props;
  const handleSubmit = () => {
            
            closeModal()
    // Handle the submit logic here
    console.log("Feedback:", selectedFeedback, "Additional Details:", additionalDetails, "No Option Dropdown Selection:", noDropdownSelection);
  };

  const closeDialog = () => {
    setIsDialogVisible(false);
    closeModal()
  };

  const closeTechDialog = () => {
    setIsTechDialogVisible(false);
    closeModal()

  };

  return (
    <>
      <Stack horizontal verticalAlign="center">
        <Label>Please Select</Label>
      </Stack>

      <div className={styles.modalBody}>
        <Dropdown
          className={styles.dropdown}
          placeholder="Select"
          options={feedbackOptions}
          onChange={handleFeedbackChange}
        />
        
        {/* Conditional rendering based on feedback selection */}
        {selectedFeedback === 'Partial' && (
          <div className={styles.additionalSection}>
            <Label>Please Log</Label>
            <TextField
              placeholder="Reason"
              value={additionalDetails}
              onChange={handleAdditionalDetailsChange}
            />
          </div>
        )}

        {selectedFeedback === 'No' && (
          <div className={styles.additionalSection}>
            <Label>Please provide additional details:</Label>
            <Dropdown
              placeholder="Select"
              options={noOptionDropdownOptions}
              onChange={handleNoOptionDropdownChange}
              className={styles.dropdown}
            />
          </div>
        )}

        {/* Submit Button */}
        {(selectedFeedback === 'Partial' || selectedFeedback === 'No') && (
          <PrimaryButton
            text="Submit"
            onClick={handleSubmit}
            className={styles.submitButton}
          />
        )}
      </div>

      {/* Dialog for "Yes" feedback */}
      <Dialog
        hidden={!isDialogVisible}
        onDismiss={closeDialog}
        dialogContentProps={{
          type: DialogType.normal,
          title: 'Success',
          subText: 'Query is logged successfully',
          styles: {
            title: { textAlign: 'center' }, // Center title
            subText: { textAlign: 'center' } // Center subtitle
          }
        }}
        modalProps={{
          isBlocking: false,
          styles: {
            main: { zIndex: 1000 } // Ensure dialog is above other content
          }
        }}
      >
        <DialogFooter className={styles.dialogFooter}>
          <DefaultButton onClick={closeDialog} text="Close" />
        </DialogFooter>
      </Dialog>

      {/* Dialog for "Tech to Verify" feedback */}
      <Dialog
        hidden={!isTechDialogVisible}
        onDismiss={closeTechDialog}
        dialogContentProps={{
          type: DialogType.normal,
          title: 'Close the last session',
          // subText: 'Close the last session',
          styles: {
            title: { textAlign: 'center' }, // Center title
            subText: { textAlign: 'center' } // Center subtitle
          }
        }}
        modalProps={{
          isBlocking: false,
          styles: {
            main: { zIndex: 1000 } // Ensure dialog is above other content
          }
        }}
      >
        <DialogFooter className={styles.dialogFooter}>
          <DefaultButton onClick={closeTechDialog} text="Close" />
        </DialogFooter>
      </Dialog>
    </>
  );
};
